var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-steps" },
    _vm._l(_vm.steps, function(step) {
      return _c(
        "div",
        {
          key: step.id,
          staticClass: "employee-task mb-2 d-flex flex-column step-box"
        },
        [
          _c(
            "div",
            {
              staticClass: "d-flex justify-content-between align-items-center"
            },
            [
              _c(
                "b-media",
                { attrs: { "no-body": "" } },
                [
                  _c(
                    "b-media-aside",
                    { staticClass: "mr-75" },
                    [
                      !step.paso.subrogadoId
                        ? _c("b-avatar", {
                            attrs: {
                              rounded: "",
                              size: "42",
                              src: step.paso.avatar
                            }
                          })
                        : _vm._e(),
                      step.paso.subrogadoId
                        ? _c("b-avatar", {
                            staticClass: "mt-25 mr-75",
                            attrs: {
                              rounded: "",
                              text: _vm._f("avatarName")(step.paso.subrogado),
                              size: "42"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _c("b-media-body", { staticClass: "my-auto" }, [
                    !step.paso.subrogadoId
                      ? _c("h6", { staticClass: "mb-0" }, [
                          _vm._v(
                            " " +
                              _vm._s(step.numeroPaso) +
                              " - " +
                              _vm._s(step.paso.responsable) +
                              " "
                          )
                        ])
                      : _vm._e(),
                    step.paso.subrogadoId
                      ? _c(
                          "h6",
                          { staticClass: "mb-0", attrs: { title: "Suplente" } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(step.numeroPaso) +
                                " - " +
                                _vm._s(step.paso.subrogado) +
                                " "
                            ),
                            _c("span", { attrs: { title: "Suplente" } }, [
                              _vm._v(" (S) ")
                            ])
                          ]
                        )
                      : _vm._e(),
                    _c("small", [
                      step.paso.aprobacionesTipoPasoId.toString() ===
                      _vm.stepTypes.proveedor.toString()
                        ? _c("b", [
                            _vm._v(" " + _vm._s(_vm.getStepType(step)) + " - ")
                          ])
                        : _vm._e(),
                      _vm.isNormal(step)
                        ? _c("span", [_vm._v(_vm._s(_vm.getRolType(step)))])
                        : _vm._e(),
                      _vm.isOffice(step)
                        ? _c("span", [_vm._v("Oficina")])
                        : _vm._e(),
                      _vm.isOfficer(step)
                        ? _c("span", [_vm._v("Oficial de parte")])
                        : _vm._e()
                    ]),
                    step.paso.responsableCorreo
                      ? _c("small", { staticClass: "d-block text-muted" }, [
                          _vm._v(
                            " " + _vm._s(step.paso.responsableCorreo) + " "
                          )
                        ])
                      : _vm._e()
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "d-flex align-items-center" },
                [
                  step.minutosEnPaso != null && step.minutosEnPaso >= 0
                    ? _c("small", { staticClass: "text-muted mr-75" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("timeApprovals")(
                                step.minutosEnPaso,
                                step.minutosEnPaso,
                                true
                              )
                            ) +
                            " "
                        )
                      ])
                    : _vm._e(),
                  _vm.editable && _vm.isPerson(step)
                    ? _c(
                        "b-avatar",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip",
                              value: "Cambiar correo",
                              expression: "'Cambiar correo'"
                            }
                          ],
                          staticClass: "mr-50 cursor-pointer",
                          attrs: {
                            rounded: "",
                            size: "24",
                            variant: "light-primary"
                          },
                          nativeOn: {
                            click: function($event) {
                              return _vm.openChangeEmail(step)
                            }
                          }
                        },
                        [
                          _c("feather-icon", {
                            attrs: { size: "14", icon: "MailIcon" }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "span",
                    [
                      _c(
                        "b-media-aside",
                        { staticClass: "mr-1 d-flex align-items-center" },
                        [
                          step.paso.distributed == 1
                            ? _c(
                                "b-avatar",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip",
                                      value:
                                        "Distribuido: se asigna a 1 persona del grupo secuencialmente",
                                      expression:
                                        "'Distribuido: se asigna a 1 persona del grupo secuencialmente'"
                                    }
                                  ],
                                  staticClass: "mr-1",
                                  attrs: {
                                    rounded: "",
                                    size: "28",
                                    variant: "light-warning"
                                  }
                                },
                                [
                                  _c("feather-icon", {
                                    attrs: { size: "18", icon: "Share2Icon" }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          step.retenido === "Y"
                            ? _c(
                                "b-avatar",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip",
                                      value: "Retenido",
                                      expression: "'Retenido'"
                                    }
                                  ],
                                  staticClass: "mr-2",
                                  attrs: {
                                    rounded: "",
                                    size: "28",
                                    variant: "light-primary"
                                  }
                                },
                                [
                                  _c("feather-icon", {
                                    attrs: { size: "18", icon: "LockIcon" }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          step.aprobacionesPasoEstadoId ===
                          _vm.flowStates.PROCESSING
                            ? _c(
                                "b-avatar",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip",
                                      value: "Procesando",
                                      expression: "'Procesando'"
                                    }
                                  ],
                                  attrs: {
                                    rounded: "",
                                    size: "28",
                                    variant: "light-warning"
                                  }
                                },
                                [
                                  _c("feather-icon", {
                                    attrs: { size: "18", icon: "LoaderIcon" }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          step.aprobacionesPasoEstadoId ===
                          _vm.flowStates.PENDING
                            ? _c(
                                "b-avatar",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip",
                                      value: "Pendiente",
                                      expression: "'Pendiente'"
                                    }
                                  ],
                                  attrs: {
                                    rounded: "",
                                    size: "28",
                                    variant: "light-secondary"
                                  }
                                },
                                [
                                  _c("feather-icon", {
                                    attrs: {
                                      size: "18",
                                      icon: "AlertCircleIcon"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          step.aprobacionesPasoEstadoId ===
                          _vm.flowStates.APPROVED
                            ? _c(
                                "b-avatar",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip",
                                      value: "Aprobado",
                                      expression: "'Aprobado'"
                                    }
                                  ],
                                  attrs: {
                                    rounded: "",
                                    size: "28",
                                    variant: "light-success"
                                  }
                                },
                                [
                                  _c("feather-icon", {
                                    attrs: { size: "18", icon: "ThumbsUpIcon" }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          step.aprobacionesPasoEstadoId ===
                          _vm.flowStates.REJECTED
                            ? _c(
                                "b-avatar",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip",
                                      value: "Rechazado",
                                      expression: "'Rechazado'"
                                    }
                                  ],
                                  attrs: {
                                    rounded: "",
                                    size: "28",
                                    variant: "light-danger"
                                  }
                                },
                                [
                                  _c("feather-icon", {
                                    attrs: {
                                      size: "18",
                                      icon: "ThumbsDownIcon"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          step.aprobacionesPasoEstadoId ===
                          _vm.flowStates.FORWARDED
                            ? _c(
                                "b-avatar",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip",
                                      value: "Reenviado",
                                      expression: "'Reenviado'"
                                    }
                                  ],
                                  attrs: {
                                    rounded: "",
                                    size: "28",
                                    variant: "light-info"
                                  }
                                },
                                [
                                  _c("feather-icon", {
                                    attrs: { size: "18", icon: "ShuffleIcon" }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          (step.aprobacionesPasoEstadoId ===
                            _vm.flowStates.PROCESSING ||
                            step.aprobacionesPasoEstadoId ===
                              _vm.flowStates.APPROVED ||
                            step.aprobacionesPasoEstadoId ===
                              _vm.flowStates.REJECTED) &&
                          step.esTemporal &&
                          !step.temporalContinuaFlujo
                            ? _c(
                                "b-avatar",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip",
                                      value: "Se devuelve al paso anterior",
                                      expression:
                                        "'Se devuelve al paso anterior'"
                                    }
                                  ],
                                  staticClass: "ml-1",
                                  attrs: {
                                    rounded: "",
                                    size: "20",
                                    variant: "light-warning"
                                  }
                                },
                                [
                                  _c("feather-icon", {
                                    attrs: { size: "18", icon: "ArrowLeftIcon" }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          (step.aprobacionesPasoEstadoId ===
                            _vm.flowStates.PROCESSING ||
                            step.aprobacionesPasoEstadoId ===
                              _vm.flowStates.APPROVED ||
                            step.aprobacionesPasoEstadoId ===
                              _vm.flowStates.REJECTED) &&
                          step.esTemporal &&
                          step.temporalContinuaFlujo
                            ? _c(
                                "b-avatar",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip",
                                      value: "Sigue al paso siguiente",
                                      expression: "'Sigue al paso siguiente'"
                                    }
                                  ],
                                  staticClass: "ml-1",
                                  attrs: {
                                    rounded: "",
                                    size: "20",
                                    variant: "light-success"
                                  }
                                },
                                [
                                  _c("feather-icon", {
                                    attrs: {
                                      size: "18",
                                      icon: "ArrowRightIcon"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          step.aprobacionesPasoEstadoId ===
                          _vm.flowStates.RETURNED
                            ? _c(
                                "b-avatar",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip",
                                      value: "Devuelto",
                                      expression: "'Devuelto'"
                                    }
                                  ],
                                  attrs: {
                                    rounded: "",
                                    size: "28",
                                    variant: "light-info"
                                  }
                                },
                                [
                                  _c("feather-icon", {
                                    attrs: {
                                      size: "18",
                                      icon: "CornerUpLeftIcon"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          step.aprobacionesPasoEstadoId ===
                          _vm.flowStates.SIGNED
                            ? _c(
                                "b-avatar",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip",
                                      value: "Firmando",
                                      expression: "'Firmando'"
                                    }
                                  ],
                                  attrs: {
                                    rounded: "",
                                    size: "28",
                                    variant: "light-warning"
                                  }
                                },
                                [
                                  _c("feather-icon", {
                                    attrs: { size: "18", icon: "PenToolIcon" }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.editingStepId === step.id
            ? _c("div", { staticClass: "change-email-form mt-1 ml-4 pl-2" }, [
                _c(
                  "small",
                  { staticClass: "text-muted font-weight-bold d-block mb-50" },
                  [_vm._v("Cambiar correo")]
                ),
                _c(
                  "div",
                  { staticClass: "d-flex align-items-center" },
                  [
                    _c("b-form-input", {
                      staticClass: "mr-50",
                      attrs: {
                        type: "email",
                        size: "sm",
                        placeholder: "Nuevo correo",
                        state: _vm.emailValid
                      },
                      model: {
                        value: _vm.newEmail,
                        callback: function($$v) {
                          _vm.newEmail = $$v
                        },
                        expression: "newEmail"
                      }
                    }),
                    _c(
                      "b-button",
                      {
                        staticClass: "mr-50",
                        attrs: {
                          variant: "primary",
                          size: "sm",
                          disabled: !_vm.emailValid || _vm.savingEmail
                        },
                        on: {
                          click: function($event) {
                            return _vm.confirmChangeEmail(step)
                          }
                        }
                      },
                      [
                        _vm.savingEmail
                          ? _c("b-spinner", { attrs: { small: "" } })
                          : _c("span", [_vm._v("Guardar")])
                      ],
                      1
                    ),
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "outline-secondary", size: "sm" },
                        on: { click: _vm.cancelChangeEmail }
                      },
                      [_vm._v(" Cancelar ")]
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm.showParticipants &&
          _vm.isGroup(step) &&
          _vm.getVisibleParticipants(step).length
            ? _c(
                "div",
                { staticClass: "participants-list mt-1 ml-4 pl-2" },
                [
                  _c("small", { staticClass: "text-muted font-weight-bold" }, [
                    _vm._v("Participantes del grupo")
                  ]),
                  _vm._l(_vm.getVisibleParticipants(step), function(
                    participant,
                    idx
                  ) {
                    return _c(
                      "div",
                      {
                        key: idx,
                        staticClass: "d-flex align-items-center mt-50"
                      },
                      [
                        _c("b-avatar", {
                          staticClass: "mr-50",
                          attrs: {
                            rounded: "",
                            size: "10",
                            variant: _vm.getParticipantVariant(participant)
                          }
                        }),
                        _c("small", [_vm._v(_vm._s(participant.nombre))]),
                        participant.aprobacionesPasoEstadoId
                          ? _c("small", { staticClass: "ml-50 text-muted" }, [
                              _vm._v(
                                " (" +
                                  _vm._s(
                                    _vm.getParticipantStatus(participant)
                                  ) +
                                  ") "
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  })
                ],
                2
              )
            : _vm._e()
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }